import {
  Activity,
  ArrowLeftRight,
  ArrowRightLeft,
  BadgeDollarSign,
  BarChart3,
  BarChart4,
  Building2,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  ChartColumn,
  ChartPie,
  Check,
  Circle,
  ClipboardList,
  CreditCard,
  FileChartPie,
  FilePlus,
  FileText,
  Files,
  Gauge,
  GitBranch,
  Handshake,
  History,
  IdCard,
  LayoutDashboard,
  LineChart,
  List,
  MapPinned,
  PackageSearch,
  PenLine,
  Receipt,
  ReceiptText,
  Route,
  ScrollText,
  Search,
  Settings,
  SlidersVertical,
  Sparkles,
  Tag,
  TrendingUp,
  Truck,
  Users,
  UserMinus,
  UserPlus,
  Wallet,
  Warehouse,
  Wrench,
  Radar,
  Bell,
} from 'lucide-react';

const menuIcons = {
  dashboard: LayoutDashboard,
  facturacion: Receipt,
  comprobantes: FileText,
  vehiculos: Truck,
  guias: PackageSearch,
  rutas: Route,
  repartos: MapPinned,
  tesoreria: Wallet,
  reportes: ChartPie,
  alertas: Bell,
  administracion: Settings,
  usuarios: Users,
  userPlus: UserPlus,
  ajustes: SlidersVertical,
  retiros: PackageSearch,
  busqueda: Search,
  etiquetas: Tag,
  filePlus: FilePlus,
  lista: List,
  lineas: GitBranch,
  confirmar: Check,
  manual: PenLine,
  files: Files,
  notas: ReceiptText,
  cobros: Wallet,
  pagos: CreditCard,
  registrar: BadgeDollarSign,
  agenda: CalendarClock,
  programar: CalendarPlus,
  historial: History,
  indicadores: Gauge,
  servicio: Activity,
  comerciales: TrendingUp,
  rrhh: IdCard,
  legajos: ClipboardList,
  altasBajas: UserMinus,
  parametros: SlidersVertical,
  stock: Warehouse,
  movimientos: ArrowLeftRight,
  depositos: Warehouse,
  transferencias: ArrowRightLeft,
  mantenimiento: Wrench,
  calendario: CalendarCheck,
  ordenes: ClipboardList,
  telemetria: Radar,
  agencias: Building2,
  operaciones: ScrollText,
  liquidaciones: ScrollText,
  convenios: Handshake,
  proveedores: Handshake,
  financieros: LineChart,
  ingresosGastos: ChartColumn,
  balance: FileChartPie,
  operativos: BarChart3,
  productividad: BarChart4,
  calidad: Sparkles,
  compras: ReceiptText,
  default: Circle,
  inventario: ClipboardList,
  clientesGestion: Users,
  choferes: IdCard,
};

export function getMenuIcon(iconKey) {
  return iconKey && menuIcons[iconKey] ? menuIcons[iconKey] : menuIcons.default;
}

export { menuIcons };
